import { render, staticRenderFns } from "./CardBodyItemNew.vue?vue&type=template&id=226ce94c&scoped=true"
import script from "./CardBodyItemNew.vue?vue&type=script&lang=ts"
export * from "./CardBodyItemNew.vue?vue&type=script&lang=ts"
import style0 from "./CardBodyItemNew.vue?vue&type=style&index=0&id=226ce94c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ce94c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226ce94c')) {
      api.createRecord('226ce94c', component.options)
    } else {
      api.reload('226ce94c', component.options)
    }
    module.hot.accept("./CardBodyItemNew.vue?vue&type=template&id=226ce94c&scoped=true", function () {
      api.rerender('226ce94c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardBodyItemNew.vue"
export default component.exports